<template>
    <div class="workshops">
        <Navigation/>
        <v-main>
            <v-container>
                <v-row>
                    <v-col cols=12>
                        <workshops-list
                            title="Les sessions ONCO'MMENCE"
                            :workshops="workshops"
                            :options.sync="options"
                            :search="search"
                            :total="total"
                            :loading="loading"
                            :loading-more="loadingMore"
                            :has-more="hasMore"
                            :all-departments="allDepartments"
                            :all-cities="allCities"
                            :departments-loading="departmentsLoading"
                            :cities-loading="citiesLoading"
                            :professionals-names="professionalsNames"
                            :professionals-names-loading="professionalsNamesLoading"
                            :slider="slider"
                            :is-oncommence="true"
                            :show-banner="showOncommenceBanner"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import WorkshopsList from '@/components/workshops/WorkshopsList'
import workshopsList from '@/mixins/workshopsList'
import { mapGetters } from 'vuex'

export default {
    name: 'WorkshopsOncommence',
    components: {
        Navigation,
        WorkshopsList
    },
    mixins: [workshopsList],
    data() {
        return {
            search: {
                ...(this.$route.query.search ? JSON.parse(this.$route.query.search) : {}),
                active: true,
                'is_aja': false,
                'is_pro': false,
                workshop_type: 'oncommence'
            }
        }
    },
    computed: {
        ...mapGetters(['profile']),
        showOncommenceBanner() {
            return this.profile?.show_oncommence_banner || false
        }
    },
    mounted() {
        this.refreshPagination(true)
        this.initAdvancedSearch()
        this.initLogos()
    }
}
</script>

<style>
.split-carousel--arrow--left,
.split-carousel--arrow--right {
    visibility: hidden !important;
}
</style> 